module.exports = "      <!-- Main Footer -->\n      <footer class=\"main-footer\">\n        <!-- To the right -->\n        <div class=\"pull-right hidden-xs\">\n        </div>\n        <!-- Default to the left -->\n        &copy; 2017 <a href=\"http://www.forgottenrecords.com\" target=\"_blank\">Forgotten Records</a>. Tous droits réservés.\n      </footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/partials/admin-footer.component.html
// module id = 471
// module chunks = 0